<template>
  <div class="content-item text-danger">
    <p v-html="declinedMessage" />
  </div>
</template>

<script>
import Constants from '@/constants.js';

export default {
  data: () => ({
    declinedMessage: `
      Unfortunately, your request was declined.<br />
      If you have reached this message in error, please reply to <b>${Constants.SUPPORT_EMAIL}</b> and someone <br class="xs-hide" />
      will be able to assist you shortly.
    `,
  }),
};
</script>

<style lang="scss">
.content-item.text-danger {
  color: #ff0000;

  @media (max-width: 575px) {
    .xs-hide {
      display: none;
    }
  }
}
</style>
